import {GeneralAction} from "../../../@types/actions";
import {SET_EVENT_MONEY_LINE} from "../../../constants/CommonConstants";
import {MoneyLineObject} from "../../../@types/response";

export const SetMarketMoneyLineAction = (data: MoneyLineObject): GeneralAction<MoneyLineObject> => ({
    type: SET_EVENT_MONEY_LINE,
    payload: data
});
